/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GongGongIDCanShu,
  ResponseApi,
  ResponseApiObject,
  UserDTO1,
  UserPassVO,
  UserResetPassDTO,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class XiTongYongHuGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags XiTongYongHuGuanLi
   * @name QueryUsingGet7
   * @summary 用户列表
   * @request GET:/dsp-admin/api/sys/users
   * @secure
   */
  queryUsingGet7 = (
    query: {
      /**
       * 页码 (1..N)
       * @format int64
       */
      pageNum: number;
      /**
       * 每页显示的数目
       * @format int64
       */
      pageSize: number;
      blurry?: string;
      /** @format int32 */
      deptId?: number;
      /** @format int32 */
      roleId?: number;
      /** @format int32 */
      status?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiObject, void>({
      path: `/dsp-admin/api/sys/users`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongYongHuGuanLi
   * @name CreateUsingPost3
   * @summary 新增用户
   * @request POST:/dsp-admin/api/sys/users
   * @secure
   */
  createUsingPost3 = (resources: UserDTO1, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/users`,
      method: "POST",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongYongHuGuanLi
   * @name UpdateUsingPut3
   * @summary 修改用户
   * @request PUT:/dsp-admin/api/sys/users
   * @secure
   */
  updateUsingPut3 = (resources: UserDTO1, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/users`,
      method: "PUT",
      body: resources,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongYongHuGuanLi
   * @name DeleteUsingDelete3
   * @summary 删除用户
   * @request DELETE:/dsp-admin/api/sys/users
   * @secure
   */
  deleteUsingDelete3 = (ids: number[], params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/users`,
      method: "DELETE",
      body: ids,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongYongHuGuanLi
   * @name GetUsingPost
   * @summary 查询用户
   * @request POST:/dsp-admin/api/sys/users/get
   * @secure
   */
  getUsingPost = (param: GongGongIDCanShu, params: RequestParams = {}) =>
    this.request<ResponseApiObject, void>({
      path: `/dsp-admin/api/sys/users/get`,
      method: "POST",
      body: param,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongYongHuGuanLi
   * @name ResetPassUsingPut
   * @summary 重置密码
   * @request PUT:/dsp-admin/api/sys/users/resetPass
   * @secure
   */
  resetPassUsingPut = (passDTO: UserResetPassDTO, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/users/resetPass`,
      method: "PUT",
      body: passDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags XiTongYongHuGuanLi
   * @name UpdatePassUsingPost
   * @summary 修改密码
   * @request POST:/dsp-admin/api/sys/users/updatePass
   * @secure
   */
  updatePassUsingPost = (passVo: UserPassVO, params: RequestParams = {}) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/sys/users/updatePass`,
      method: "POST",
      body: passVo,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new XiTongYongHuGuanLi();
